import React, { Component } from 'react';
import { object } from 'prop-types';
import { isEmpty } from 'lodash';
import { metric } from '@fiverr-private/perseus';
import { PersonalizedSection } from '@fiverr-private/personalized_content/src';
import { PERSONALIZED_CONTENT_RECOMMENDED_IN_SC } from '../../utils/carousels';
import SafePureComponent from '../shared/SafePureComponent';
import { getSliderConfig } from '../shared/GigCardCarouselWrapper/config';
import './style.scss';

const { sliderBaseNum, sliderBreakpoints } = getSliderConfig('bottom');

// Wrap personalized component in a pure component in order to avoid multiple scroll events
// which create multiple impressionable object.
// todo: change the className once the PersonalizedSection return more than one carousel

class PersonalizedSectionWrapper extends Component {

    constructor(props) {
        super(props);

        const {
            personalizedContent
        } = this.props;

        this.isEmptyGigs = isEmpty(personalizedContent);

        metric.count(`carousel.${PERSONALIZED_CONTENT_RECOMMENDED_IN_SC}.empty_gigs.${this.isEmptyGigs}`);
    }

    render() {
        const { personalizedContent } = this.props;

        if (this.isEmptyGigs) {
            return null;
        }

        return (
            <div className="recommended-in-sc">
                <PersonalizedSection sectionName="bottom"
                    isLoading={true}
                    sliderBaseNum={sliderBaseNum}
                    sliderBreakpoints={sliderBreakpoints}
                    personalizedContentRes={personalizedContent}/>
            </div>
        );
    }
}

PersonalizedSectionWrapper.propTypes = {
    personalizedContent: object
};

export { PersonalizedSectionWrapper };
export default SafePureComponent(PersonalizedSectionWrapper);
